import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'search.page.filter.frequentQuestion.title',
    defaultMessage: 'Questions fréquentes',
  },
  frequentQuestions1: {
    id: 'search.page.filter.frequentQuestions1',
    defaultMessage: `Comment ça marche ?`,
  },
  frequentQuestions2: {
    id: 'search.page.filter.frequentQuestions2',
    defaultMessage: `Qu’est-ce qu’un essai offert ?`,
  },
  frequentQuestions3: {
    id: 'search.page.filter.frequentQuestions3',
    defaultMessage: 'Combien ça coûte ?',
  },
});
